import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import {
   ChangeBrickScaling,
   ChangeBrickTitle,
} from '../../../../store/dashboard/brick-wall/brick-settings/common-brick-settings/common-brick-settings.actions';
import { TranslateService } from '@ngx-translate/core';
import { map, switchMap } from 'rxjs/operators';
import { BrickInstancesSelectors } from '../../../../store/dashboard/brick-wall/brick-instances/brick-instances.selectors';
import { CommonBrickSettingsSelectors } from '../../../../store/dashboard/brick-wall/brick-settings/common-brick-settings/common-brick-settings.selectors';

@Component({
   selector: 'samweb-brick-common-settings',
   templateUrl: './brick-common-settings.component.html',
   styleUrls: ['./brick-common-settings.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrickCommonSettingsComponent implements OnInit {
   constructor(private store: Store, private translationService: TranslateService) {}

   @Input()
   public brickInstanceId: string;

   brickTitleSettingValue$: Observable<string>;
   brickScaling$: Observable<number>;
   brickScalingEffective$: Observable<number>;
   brickScalingText$: Observable<string>;
   brickOriginalTitle$: Observable<string>;

   ngOnInit() {
      this.brickTitleSettingValue$ = this.store.select(CommonBrickSettingsSelectors.getOverwrittenBrickTitleFn).pipe(map((fn) => fn(this.brickInstanceId)));
      this.brickScaling$ = this.store.select(CommonBrickSettingsSelectors.getBrickScalingFn).pipe(map((fn) => fn(this.brickInstanceId)));
      this.brickScalingEffective$ = this.store.select(CommonBrickSettingsSelectors.getEffectiveBrickScalingFn).pipe(map((fn) => fn(this.brickInstanceId)));
      this.brickOriginalTitle$ = this.store.select(BrickInstancesSelectors.brickDescriptionFn).pipe(
         map((fn) => fn(this.brickInstanceId)),
         switchMap((x) => this.translationService.stream(x.definition.brickTitleTranslationKey))
      );

      this.brickScalingText$ = combineLatest([this.brickScaling$, this.brickScalingEffective$]).pipe(
         switchMap(([brickScaling, brickScalingEffective]) =>
            this.translationService.stream('brick.brick-management.settings.category_common.brick_scaling_value_info', {
               brickScale: brickScaling,
               brickScaleEffective: brickScalingEffective,
            })
         )
      );
   }

   brickTitleChanged(value: string) {
      this.store.dispatch(new ChangeBrickTitle(this.brickInstanceId, value));
   }

   brickScalingChanged(scaleValue: number) {
      this.store.dispatch(new ChangeBrickScaling(this.brickInstanceId, scaleValue));
   }
}
